import React from "react";

import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

type Props = { className?: string };

export const StrikeThrough = (props: SvgIconProps & Props) => {
    return (
        <SvgIcon {...props}>
            <path d="M16.2451 7V8.27273H12.7726V17.5H11.2274V8.27273H7.75487V7H16.2451Z" />
            <path d="M7.5 13.7121H16.5V14.9091H7.5V13.7121Z" />
        </SvgIcon>
    );
};
